var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { createMaybeSelectorS2 } from '@ally/data-selectors';
import * as accounts from './base';
import deposit from './deposit';
import invest from './invest';
import { reduceInvestTotal, reduceDepositTotal } from './etc/utils';
var getAll = createMaybeSelectorS2(accounts.getDeposit, accounts.getInvest, function (depositAccountSummary, investAccountSummary) {
    return { deposit: depositAccountSummary, invest: investAccountSummary };
});
var getOpenInternal = createMaybeSelectorS2(invest.getOpen, deposit.getOpenInternal, function (investAccounts, depositAccounts) { return __spread(investAccounts, depositAccounts); });
var getTotalBalance = createMaybeSelectorS2(invest.getOpen, deposit.getOpenInternal, function (investAccountSummary, depositAccountSummary) {
    var investTotal = investAccountSummary.reduce(reduceInvestTotal, 0);
    var depositTotal = depositAccountSummary.reduce(reduceDepositTotal, 0);
    return investTotal + depositTotal;
});
var getAllForDropdown = createMaybeSelectorS2(deposit.getAllForDropdown, invest.getAllForDropdown, function (uiDeposit, uiInvest) {
    return __spread(uiInvest, uiDeposit);
});
export default {
    getAll: getAll,
    getOpenInternal: getOpenInternal,
    getTotalBalance: getTotalBalance,
    getAllForDropdown: getAllForDropdown,
};
//# sourceMappingURL=depositAndInvest.js.map